<template>
    <Main>
        <div slot="main" class="main slaughter">
            <div class="bank_title">
                <Header :data='headerInfo'></Header>
            </div>
            <div class="city" v-if="headDate != '/nmzlqlogin'">
            </div>
            <div class="content">
                <div class="left">
                    <div class="l_t">
                        <div class="server">
                            <div>
                                <span class="card_">羊只(白条)收购价格行情</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <!-- <div class="date">
                                <span @click="serviceStatusBtn('first')"
                                    :class="{ active: serviceStatus === 'first' }">近7日</span>
                                <span @click="serviceStatusBtn('three')"
                                    :class="{ active: serviceStatus === 'three' }">近30日</span>
                                <span @click="serviceStatusBtn('six')"
                                    :class="{ active: serviceStatus === 'six' }">近3月</span>
                            </div> -->
                        </div>
                        <div class="block">
                            <div class="box_">
                                <div class="box">
                                    <div class="small_big" v-for="(item, i) in sheepList" :key="i" @click="small_Btn(i)"
                                        :class="{ active_2: small_Status == i }">
                                        <span>{{ item.price }} <i>元/kG</i> </span>
                                        <span>{{ item.title }}</span>
                                        <div class="top_box"></div>
                                    </div>
                                </div>
                            </div>
                            <img class="img_1" @click="btn" v-if="sheepList.length >= 4" src="../../assets/left_map.png"
                                alt="">
                            <img class="img_2" @click="btn" v-if="sheepList.length >= 4" src="../../assets/right_map.png"
                                alt="">
                        </div>
                        <div id="lineChart_1"></div>
                    </div>
                    <div class="l_b">
                        <div class="server">
                            <div>
                                <span class="card_">最新屠宰入场动态</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                        </div>
                        <div class="l_top">
                            <div class="top">
                                <span>今日入场羊只(只)</span>
                                <!-- <span>{{ slaughterAd.butcherSheepNum || 0 }}</span> -->
                                <span>{{ slaughterTotal || 0 }}</span>
                            </div>
                            <!-- <div class="top" :style="{ marginLeft: headDate != '/nmzlqlogin' ? '0.68' : '0' }">
                                <span>今日入场牛只(头)</span>
                                <span>{{ slaughterAd.butcherCowNum || 0 }}</span>
                            </div> -->
                        </div>
                        <dv-scroll-board :config="config" @mouseover="mouseover_1"
                            style="width:6.69rem;height:5rem;margin-top: .25rem;margin-left: .25rem;" />
                    </div>
                </div>
                <div class="center">
                    <div class="c_t">
                        <div class="l">
                            <div class="box_1 box_12">
                                <img src="../../assets/tz_niu1.png" alt="">
                                <div class="text">
                                    <!-- <span>9999</span> -->
                                    <dv-digital-flop :config="config2" style="min-width:1.5rem;height:0.45rem;" />
                                    <span>当前库存(kg)</span>
                                </div>
                            </div>
                            <div class="box_2 box_12">
                                <img src="../../assets/tz_niu2.png" alt="">
                                <div class="text">
                                    <!-- <span>9999</span> -->
                                    <dv-digital-flop :config="config3" style="min-width:1.5rem;height:0.45rem;" />
                                    <span>库存货值(万元)</span>
                                </div>
                            </div>
                        </div>
                        <div class="box_3">
                            <!-- <span>6666</span> -->
                            <dv-digital-flop :config="config4" style="min-width:2rem;height:0.5rem;margin-top: -0.05rem;" />
                            <span>累计采购金额({{ unitSheep.unit }})</span>
                            <video src="../../assets/HUD_1.mp4" muted autoplay="autoplay" loop="loop"></video>
                        </div>
                        <div class="r">
                            <div class="box_4 box_45">
                                <div class="text">
                                    <!-- <span>9999</span> -->
                                    <dv-digital-flop :config="config5" style="min-width:1.5rem;height:0.45rem;" />
                                    <span>累计收购羊只(只)</span>
                                </div>
                                <img src="../../assets/tz_sheep1.png" alt="">
                            </div>
                            <div class="box_5 box_45">
                                <div class="text">
                                    <!-- <span>9999</span> -->
                                    <dv-digital-flop :config="config6" style="min-width:1.5rem;height:0.45rem;" />
                                    <span>供应商(家)</span>
                                </div>
                                <!-- <img style="margin-left:0.45rem" src="../../assets/tz_round.png" alt=""> -->
                                <img src="../../assets/tz_sheep2.png" alt="">
                            </div>
                        </div>
                    </div>
                    <div class="c_b">
                        <div class="server">
                            <div>
                                <span class="card_">活畜屠宰交易分布</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="date" v-show="headDate != '/nmzlqlogin'">
                                <span @click="statusBtn('羊')" :class="{ active: status === '羊' }">羊</span>
                                <!-- <span @click="statusBtn('牛')" :class="{ active: status === '牛' }">牛</span> -->
                            </div>
                        </div>
                        <div class="l_top">
                            <div class="top">
                                <span>{{ butcherData.butcherNum }}</span>
                                <span>累计入场{{ status }}只数量{{ status === '牛' ? '(头)' : '(只)' }}</span>
                            </div>
                            <div class="top">
                                <span>{{ centerData.num }}</span>
                                <span>{{ status }}只累计交易金额({{ centerData.unit }})</span>
                            </div>
                        </div>
                        <div class="l_c" style="margin-top: .15rem;">
                            <div class="ret" v-if="goBackShow" @click="goBack">返回上一层</div>
                            <div>
                                <el-select class="select" v-model="time" :placeholder="timeChange" @change="changeYearData"
                                    style="margin-right: 0.13rem;font-size:0.13rem">
                                    <el-option v-for="item in times" :key="item.value" :label="item.label"
                                        :value="item.value">
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div id="growthChart" v-if="isShow"></div>
                    </div>
                </div>
                <div class="right">
                    <div class="r_t">
                        <div class="server">
                            <div>
                                <span class="card_">成品出入库统计</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="date">
                                <span @click="serviceStatusBtn_1('first_1')"
                                    :class="{ active: serviceStatus_1 === 'first_1' }">近7日</span>
                                <span @click="serviceStatusBtn_1('three_1')"
                                    :class="{ active: serviceStatus_1 === 'three_1' }">近30日</span>
                                <span @click="serviceStatusBtn_1('six_1')"
                                    :class="{ active: serviceStatus_1 === 'six_1' }">近3月</span>
                            </div>
                        </div>
                        <div class="l_top">
                            <div class="top">
                                <span>{{ productData.inboundWeight || 0 }}</span>
                                <span>入库总重(kg)</span>
                            </div>
                            <div class="top">
                                <span>{{ productData.outboundWeight || 0 }}</span>
                                <span>出库总重(kg)</span>
                            </div>
                        </div>
                        <!-- <div id="lineChart_2"></div> -->
                        <div id="barChart"></div>
                    </div>
                    <div class="r_b">
                        <div class="server" v-show="false">
                            <div>
                                <span class="card_">监控视频</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <div class="date" v-show="false">
                                <span @click="serviceStatusBtn_2('first_2')"
                                    :class="{ active: serviceStatus_2 === 'first_2' }">近7日</span>
                                <span @click="serviceStatusBtn_2('three_2')"
                                    :class="{ active: serviceStatus_2 === 'three_2' }">近30日</span>
                                <span @click="serviceStatusBtn_2('six_2')"
                                    :class="{ active: serviceStatus_2 === 'six_2' }">近3月</span>
                            </div>
                        </div>
                        <div class="server video_title">
                            <div>
                                <span class="card_">监控视频</span>
                                <img style="margin-left: 0.25rem;" src="../../assets/hhr_right.png" alt="">
                            </div>
                            <!-- v-if="this.firstList && this.firstList.length > 1" @command="selectLive" -->
                            <el-dropdown trigger="click" v-if="this.firstList && this.firstList.length > 1"
                                @command="selectLive">
                                <span style="margin-left: .1rem" class="el-dropdown-link">
                                    {{ command }}<i class="el-icon-arrow-down el-icon--right"></i>
                                </span>
                                <!-- {{ command }} -->
                                <el-dropdown-menu style="border: none!important;" slot="dropdown">
                                    <template>
                                        <!-- v-if="videoList.length > 1" -->
                                        <el-dropdown-item v-for="(item, index) in firstList" :key="index" :command='item'>
                                            {{ item.storehouseAddress }}</el-dropdown-item>
                                    </template>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                        <div class="quan">
                            <div class="cattle_">
                                <span></span>
                                <!-- <span>{{ (currentDeviceInfo.storehouseAddress||'')+'-'+(currentDeviceInfo.mountLocation||'') }}</span> -->
                                {{ currentDeviceInfo.storehouseAddress }}
                            </div>
                            <div class="screenFull" @click="videoShow" v-if="false">
                                <img src="../../assets/screen.png" alt="">
                                <span style="font-size:.15rem">全屏</span>
                            </div>
                        </div>
                        <div class="device_main">

                            <div class="video_box">
                                <div class="device_box" ref="device_box">

                                    <div id="myPlayer" v-if="((currentDeviceInfo.deviceType == 3 && !showImg))"></div>
                                    <video
                                        v-else-if="((currentDeviceInfo.deviceType == 1 && !showImg_1) || (currentDeviceInfo.deviceType == 2 && !showImg_2))"
                                        autoplay controls width="100%" height="100%" muted id="myVideo"></video>
                                    <div v-else
                                        style="width: 6.2rem;height: 4.65rem;background-color: #000308;display: flex;justify-content: center;align-items: center;flex-direction: column;">
                                        <img src="../../assets/v_img.png"
                                            style="width: 2.29rem;height: 2rem;display: block;" alt="">
                                        <p
                                            style="font-size: 0.15rem;font-family: Source Han Sans CN-Normal, Source Han Sans CN;font-weight: 350;color: #FFFFFF;margin-top: .25rem;margin-left: .3rem;">
                                            暂无视频</p>
                                    </div>
                                </div>
                                <div class="top_box"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <video src="../../assets/66.mp4" muted autoplay="autoplay" loop="loop"></video>
                <div v-if="isShow1" class="big_box">
                    <div class="video_b">
                        <span class="el-icon-close close_icon" @click="closeIcon"></span>
                        <div class="show_video">
                            <!-- <video src="../../assets/login-bg-2.mp4" autoplay="autoplay" loop class="fillWidth"
                                                                        muted='muted'>
                                                                    </video> -->
                            <div class="quan">
                                <div class="cattle_">
                                    <span></span>
                                    <span>123</span>
                                    <!-- {{ currentDeviceInfo.mountLocation }} -->
                                </div>
                            </div>
                            <div id="myVideo1"></div>
                            <!-- v-if="currentDeviceInfo.deviceType == 3" -->
                            <video autoplay controls width="100%" height="100%" muted id="myVideo2"
                                style="margin-top: .2rem;"></video>
                            <!-- v-else -->
                        </div>
                        <div class="listVideo">
                            <div class="list_video" v-for="(item, i) in deviceList" :key="i" @click="btnvideo(i)">
                                <span>{{ item.mountLocation }}</span>
                                <div class="box_img">
                                    <img src="../../assets/Aershan-niu-bg.jpg" alt="">
                                    <div v-if="videoNum == i" id="shoadow">正在播放中</div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Main>
</template>
  
<script>
import Main from "@/components/main.vue";
import Header from "../../components/headerPrise.vue";
import { toDay, toEnd, toThreeDay, toThreeEnd, getfirstDateAndlastDate } from './time'
export default {
    components: {
        Main,
        Header,
        // XChart
    },
    data() {
        return {
            firstList: [],//监控列表
            command: '',
            currentDeviceInfo: {},
            showImg: false,//萤石云
            showImg_1: false,//国标
            showImg_2: false,//无AI视频，显示图片
            totalInventoryAmount: 0,
            formTable: [],
            standbyTable: [],
            screenData: {},
            changData: {},
            sheepBuyPriceRank: {},//羊只收购趋势数据
            sheepList: [],
            sheepData: [],
            cowBuyPriceRank: {},//牛只收购价格行情
            cowList: [],
            cowData: [],
            middleTopInfo: {},//中间数据
            slaughterAd: {}, // 屠宰入场动态
            slaughterTradeDis: {},//屠宰交易分布
            slaughterTradeDis2023: {},//屠宰交易分布2023年数据
            csData: {},//存储单个牛羊屠宰交易分布
            sortRuleFlag: '0',//排序规则，可以传0，1，2这三个值，分别代表累计交易金额从高到低，信用值从高到低，贷款结算金额从高到低排序
            sortBy: '',
            companyName: '',
            total: 0,
            provinces: [],
            citys: [],
            province: '内蒙古自治区',
            city: '锡林郭勒盟',
            chart: null,
            isShow: true,//下钻dom显示隐藏
            goBackShow: false,
            dataIndex: 0,
            config: {},
            config1: {},
            config2: {},
            config3: {},
            config4: {},
            config5: {},
            config6: {},
            serviceStatus: 'first',
            status: "羊",
            serviceStatus_1: 'three_1',
            serviceStatus_2: 'first_2',
            smallStatus: 0,
            small_Status: 0,
            num: 0,
            time: '1',
            times: [

            ],
            growData: [],
            headDate: '',//判断是否为正蓝旗登录
            timeChange: '',
            breederList: [],
            unitCow: {},//牛只金额
            unitSheep: {},//羊只金额
            type: 1,//变量控制显示真实值或者**
            butcherData: {},//屠宰交易数据
            centerData: { num: 0, unit: '元' },
            sheepTotal: 0,
            cowTotal: 0,
            growdata: [],
            videoNum: 0,
            isShow1: false,//视频显示
            deviceList: [{ mountLocation: '123' }, { mountLocation: '456' },],
            productData: {},
            supplierNum: 0,
            slaughterTotal: 0,//今日入场羊只
        };
    },
    watch: {},
    created() {
        this.headDate = window.localStorage.getItem('LOGIN')
        if (this.headDate != '/nmzlqlogin') {
            this.timeChange = '2023'
            this.times = [
                { value: '0', label: '2022' },
                { value: '1', label: '2023' },
            ]
        } else {
            this.timeChange = '2023'
            this.times = [
                { value: '1', label: '2023' },
            ]
        }

        this.userInfo = JSON.parse(window.localStorage.getItem('NMYDATAUSERINFO'))
        console.log(this.userInfo, '7890');
        this.headerInfo = {
            name: window.localStorage.getItem('screenName')
        }
        // 新接口中间数据
        this.getCenterData()
        // 新接口获取屠宰入场动态
        this.getTrends()
        // 新接口获取企业排行
        // this.serviceStatusBtn_2(this.serviceStatus_2)
        // 新接口获取屠宰交易
        // this.getButcher()
        // 获取出入库
        this.serviceStatusBtn_1(this.serviceStatus_1)
        this.statusBtn(this.status)
        // 获取摄像头安装位置
        this.equipmentPlaceList()
        this.getData()


    },
    mounted() {

    },
    methods: {
        equipmentPlaceList() {
            this.$http({
                url: 'mesapp-service/rongAn/equipmentList',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "tenantId": this.userInfo.tenantId
                    // "tenantId": '1679786328140214274'

                },
            }).then(res => {
                const data = res.data.result
                if (res.data.code == 200) {
                    this.firstList = data
                    this.firstList.forEach((item, i) => {
                        item.storehouseAddress = (item.storehouseAddress || '') + '-' + (item.mountLocation || '')
                    })
                    if (document.getElementById('myPlayer')) { document.getElementById('myPlayer').innerHTML = '' }
                    this.showImg = false
                    this.showImg_1 = false
                    this.showImg_2 = false
                    if (this.firstList.length > 0) {
                        this.command = this.firstList[0].storehouseAddress
                        //  (this.firstList[0].storehouseAddress||'')+'-'+(this.firstList[0].mountLocation||'')
                        this.currentDeviceInfo = this.firstList[0]
                        if (this.currentDeviceInfo.deviceType == 2) {
                            this.getLiveVideoUrl()
                        } else if (this.currentDeviceInfo.deviceType == 1) {
                            this.getPasturePlayUrl()
                        } else {
                            this.getPlayUrl()
                        }
                    } else {
                        this.currentDeviceInfo = {}
                    }

                }
            })
        },
        getLiveVideoUrl() {
            this.$http({
                url: 'ffsapp-service/pasture/getLiveVideoUrl',
                // url: 'https://gateway.east-mind.com/ffsapp-service/pasture/getLiveVideoUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    ezvizId: this.currentDeviceInfo.ezvizId,
                    channelCode: this.currentDeviceInfo.channelCode
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    if (data.result.code === 200) {
                        this.flv_destroy()
                        this.playerVideo(data.result.data)
                    } else {
                        this.showImg_2 = true
                        // this.$message.error(data.result.message);
                    }
                } else {
                    // this.$message.error(data.message);
                }
            })
        },
        getPlayUrl() {
            let params = {
                deviceCode: this.currentDeviceInfo.deviceCode,
                channelCode: this.currentDeviceInfo.channelCode
            }
            if (this.currentDeviceInfo.deviceType == 3) {
                params.ezvizId = this.currentDeviceInfo.ezvizId;
            }

            this.$http({
                url: 'ffsapp-service/ezviz/getPlayUrl',
                // url: 'https://gateway.east-mind.com/ffsapp-service/ezviz/getPlayUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    channelCode: this.currentDeviceInfo.channelCode,
                    ezvizId: this.currentDeviceInfo.ezvizId
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.setCameras(data.result)
                } else if (data.code === 500 || data.message) {
                    this.showImg = true
                    const _this = this
                    if (_this.decoder && _this.decoder.stop) {
                        _this.decoder.stop()
                        _this.decoder = {}
                        _this.camerasListItem = {}

                    }
                    // alert('111')
                    // this.$message.error(data.message);
                }
            })
        },
        getPasturePlayUrl() {
            this.$http({
                url: 'ffsapp-service/pasture/getPlayUrl',
                // url: 'https://gateway.east-mind.com/ffsapp-service/pasture/getPlayUrl',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    deviceCode: this.currentDeviceInfo.deviceCode,
                    channelCode: this.currentDeviceInfo.channelCode
                },
            }).then(res => {
                const data = res.data;
                if (data.code === 200) {
                    this.flv_destroy()
                    this.playerVideo(data.result.httpsFmp4)
                } else {
                    this.showImg_1 = true
                    // this.$message.error(data.message);
                }
            })
        },
        setCameras(item) {
            // setTimeout(() => {
            const _this = this
            // if (_this.decoder && _this.decoder.stop) {
            //     _this.decoder.stop()
            //     _this.decoder = {}
            //     _this.camerasListItem = {}
            //     document.getElementById('myPlayer').innerHTML = ''
            // }
            const w = this.$refs.device_box.offsetWidth
            const h = this.$refs.device_box.offsetHeight
            this.$nextTick(() => {
                // if (document.getElementById('myPlayer')) document.getElementById('myPlayer').innerHTML = ''
                _this.camerasListItem = item
                _this.decoder = new this.$EZUIKit.EZUIKitPlayer({
                    id: 'myPlayer',
                    url: _this.camerasListItem.url,
                    accessToken: _this.camerasListItem.accessToken,
                    autoplay: true,
                    decoderPath: '/ezuikit',
                    width: w,
                    height: h,
                    splitBasis: 1,
                    // template: 'pcLive', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版; theme-可配置主题； 
                    // plugin: ['talk'],                       // 加载插件，talk-对讲 
                })
            })
            // this.videoModelShow = true
            // }, 5000)

        },
        flv_destroy() {
            if (this.flvPlayer) {
                this.flvPlayer.pause();
                this.flvPlayer.unload();
                this.flvPlayer.detachMediaElement();
                this.flvPlayer.destroy();
                this.flvPlayer = null;
            }
        },
        playerVideo(url) {
            if (flvjs.isSupported()) {
                this.$nextTick(() => {
                    let typeValue = this.currentDeviceInfo.deviceType == 2 ? "flv" : "mp4";
                    var videoElement = document.getElementById("myVideo");
                    this.flvPlayer = flvjs.createPlayer({
                        type: typeValue,
                        url: url,
                        isLive: true,
                        hasAudio: false,
                        hasVideo: true,
                        withCredentials: false,
                        autoplay: false,
                        cors: true,
                    });
                    this.flvPlayer.attachMediaElement(videoElement);
                    this.flvPlayer.load();
                    this.flvPlayer.play();
                });
            } else {
                this.$message({
                    type: "warning",
                    message: "加载失败",
                });
            }
        },
        selectLive(command) {
            this.command = command.storehouseAddress
            this.currentDeviceInfo = command
            if (document.getElementById('myPlayer')) { document.getElementById('myPlayer').innerHTML = '' }
            this.showImg = false
            this.showImg_1 = false
            this.showImg_2 = false
            this.$nextTick(() => {
                this.currentDeviceInfo = command
            })
            if (this.currentDeviceInfo.deviceType == 3) {
                this.$nextTick(() => {
                    this.getPlayUrl()
                })
            } else if (this.currentDeviceInfo.deviceType == 1) {
                this.$nextTick(() => {
                    this.getPasturePlayUrl()
                })
            } else if (this.currentDeviceInfo.deviceType == 2) {
                this.$nextTick(() => {
                    this.getLiveVideoUrl()
                })
            }
            // this.pastureId = command.pastureId
            // this.userPhone = command.userName
            // this.getDeviceList()
        },
        trendOfFinishedProducts(startTime, endTime) {
            this.$http({
                url: 'mesapp-service/showScreen/trendOfFinishedProducts',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "startTime": startTime, //入厂时间 开始时间
                    "endTime": endTime, //入场时间 结束时间
                    "tenantId": this.userInfo.tenantId
                },
            }).then(res => {
                const data = res.data.result
                if (res.data.code == 200) {
                    let label = []
                    let value = []
                    let value1 = []
                    this.productData = data

                    data.trendList.forEach((item) => {
                        item.xaxis = item.xaxis.split('-').splice(1, 3).join('-')
                        label.push(item.xaxis)
                        value.push(item.yaxisLeft)//入库
                        value1.push(item.yaxisRight)//出库

                    })
                    this.growdata = [
                        { title: "入库", label: label, value: value },
                        { title: "出库", label: label, value: value1 },
                    ]
                    this.setBarChart(this.growdata, 'barChart')
                }
            })
        },
        videoShow() {
            this.isShow1 = true
            // this.setVideo()
        },
        closeIcon() {
            this.isShow1 = false
            const _this = this
            if (_this.decoder && _this.decoder.stop) {
                _this.decoder.stop()
                _this.decoder = {}
                _this.camerasListItem = {}
                if (document.getElementById('myVideo1').innerHTML != '') {
                    document.getElementById('myVideo1').innerHTML = ''
                }
            }
            if (this.flvPlayer) {
                this.flvPlayer.pause();
                this.flvPlayer.unload();
                this.flvPlayer.detachMediaElement();
                this.flvPlayer.destroy();
                this.flvPlayer = null;
            }
            this.$nextTick(() => {
                this.command = this.firstList[0].storehouseAddress
                // this.pastureId = this.firstList[0].pastureId
                // this.userPhone = this.firstList[0].userName
                // this.videoNum = 0
                this.getDeviceList()
            })
        },
        btnvideo(val) {
            this.videoNum = val

            // this.$nextTick(() => {
            //     this.currentDeviceInfo = this.deviceList[val]
            // })
            // if (this.currentDeviceInfo.deviceType == 3) {
            //     this.$nextTick(() => {
            //         this.getPlayUrl()
            //     })
            // } else if (this.currentDeviceInfo.deviceType == 1) {
            //     this.$nextTick(() => {
            //         this.getPasturePlayUrl()
            //     })
            // } else if (this.currentDeviceInfo.deviceType == 2) {
            //     this.$nextTick(() => {
            //         this.getLiveVideoUrl()
            //     })
            // }
        },
        //柱状图
        setBarChart(data, dom) {
            var chart = this.$echarts.init(document.getElementById(dom));
            var option = {
                legend: {
                    top: "3%",
                    right: "3%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                    data: [
                        {
                            name: data[0].title,
                            textStyle: {
                                color: '#0EDAE2'
                            },
                        },
                        {
                            name: data[1].title,
                            textStyle: {
                                color: '#00ACFC'
                            },
                            // bottom: 10
                        }
                    ]
                },
                grid: {
                    top: '25%',
                    left: '3%',
                    right: '3%',
                    bottom: '3%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        color: '#FFFFFF',
                        rotate: 30,
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    scale: false,
                    axisTick: {
                        // X轴线 刻度线
                        // show: true,
                        // inside: true,
                        // alignWithLabel: true
                        show: false,
                    },
                    data: data[0].label
                },
                yAxis:
                {
                    name: '吨',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 40, 0, 0],
                        lineHeight: 45,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 4,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },

                series: [
                    {
                        name: data[0].title,
                        data: data[0].value,
                        type: 'bar',
                        symbol: 'circle',
                        barWidth: 10,
                        itemStyle: {
                            opacity: 1,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: '#0BE5E1',
                                },
                                {
                                    offset: 0,
                                    color: '#06FDF5',
                                },
                            ]),
                        },
                    },
                    {
                        name: data[1].title,
                        data: data[1].value,
                        type: 'bar',
                        symbol: 'circle',
                        barWidth: 10,
                        itemStyle: {
                            opacity: 1,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: '#2C9FFE',
                                },
                                {
                                    offset: 0,
                                    color: '#00ACFC',
                                },
                            ]),
                        },
                        // backgroundStyle: {
                        //     color: 'rgba(44, 118, 254, 0.2)'
                        // },
                    },
                ],
                tooltip: {//鼠标悬浮提示数据
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    // formatter: function (params) {
                    //     // console.log(params, 2)

                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                }
            };
            chart.clear()
            chart.setOption(option)
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },
        changeSpot() {
            this.formTable.forEach((item) => {
                for (var key in item) {
                    if (key != 'companyName') {
                        item[key] = "******"
                    }
                }

            })
        },
        getButcher(status) {
            let startTime = null
            let endTime = null
            let year = null
            let dateResult = {}
            if (this.time == '1' && !this.goBackShow) {
                startTime = '2023-01-01'
                endTime = "2023-12-31"
            } else if (this.time == '0' && !this.goBackShow) {
                startTime = '2022-01-01'
                endTime = "2022-12-31"
            } else {
                this.time == '0' ? (year = '2022') : (year = '2023')
                dateResult = getfirstDateAndlastDate(`${year}-${this.dataIndex < 10 ? '0' + this.dataIndex : this.dataIndex}-10`)
                startTime = dateResult.firstDate
                endTime = dateResult.lastDate
            }
            this.$http({
                url: 'mesapp-service/showScreen/trendOfButcher',
                //请求方式
                method: 'post',
                //传递的参数
                data: {

                    "materialsType": status, //原料类型 1羊 2牛,非必传，如果不传查询所有
                    "startTime": startTime, //入厂时间 开始时间
                    "endTime": endTime,  //入场时间 结束时间
                    "tenantId": this.userInfo.tenantId
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    let label = []
                    let totalValue = []
                    let moneyValue = []
                    this.growData = []
                    this.butcherData = data.result
                    var arr = this.butcherData.finalAmount.split('')
                    var str = ''
                    for (let index = 0; index < 2; index++) {
                        arr.forEach((item, i) => {
                            if (isNaN(Number(item)) && item != '.') {
                                str += item
                                arr.splice(i, 1)
                            }
                        })

                    }
                    this.centerData.unit = str
                    this.centerData.num = arr.join('')
                    this.butcherData.trendList.forEach((item) => {
                        label.push(item.xaxis)
                        totalValue.push(item.yaxisRight)
                        moneyValue.push(item.yaxisLeft)
                    })
                    this.growData = [
                        {
                            title: '屠宰量', label: label,
                            value: totalValue
                        },
                        {
                            title: '交易金额', label: label,
                            value: moneyValue
                        },
                    ]
                    this.growthChart(this.growData)
                    console.log(data, '123');
                }
            })
        },
        // 牛羊切换
        statusBtn(val) {
            let status = null
            this.status = val
            if (val === '牛') {
                status = 2

            }
            if (val === '羊') {
                status = 1


            }
            this.getButcher(status)
        },
        getCenterData() {
            this.$http({
                url: 'mesapp-service/showScreen/produce/singleCount',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "materialsType": null,
                    "tenantId": this.userInfo.tenantId
                },
            }).then(res => {
                this.middleTopInfo = res.data.result
                console.log(res.data.result, '777777777');
                this.slaughterTotal = res.data.result.butcherNumToday && Number(res.data.result.butcherNumToday)//库存货值
                this.totalInventoryAmount = res.data.result.totalInventoryAmount && Number(res.data.result.totalInventoryAmount)//库存货值
                this.cowTotal = res.data.result.totalInventoryWeight && Number(res.data.result.totalInventoryWeight)//库存重量
                // this.unitCow = res.data.result.finalAmountCowThisYear && this.changeMoney(Number(res.data.result.finalAmountCowThisYear))
                this.supplierNum = res.data.result.supplierNum && Number(res.data.result.supplierNum)//供应商数量
                this.sheepTotal = res.data.result.butcherSheepNumThisYear && Number(res.data.result.butcherSheepNumThisYear)
                this.unitSheep = res.data.result.finalAmountSheepThisYear && this.changeMoney(Number(res.data.result.finalAmountSheepThisYear))
                this.centerChange()
            })
        },
        centerChange() {
            this.$nextTick(() => {
                this.config2 = {
                    number: [0],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 21,//字体大小
                        fill: '#FFE11D',//字体颜色
                        fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                        fontWeight: 'bold'
                    },
                    textAlign: 'left',
                    // toFixed: 2,
                }
                this.config3 = {
                    number: [0],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 21,//字体大小
                        fill: '#FFE11D',//字体颜色
                        fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                        fontWeight: 'bold'
                    },
                    textAlign: 'left',
                    // toFixed: 2,
                }
                this.config4 = {
                    number: [0],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 25,//字体大小
                        fill: '#FFE11D',//字体颜色
                        fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                        fontWeight: 'bold'
                    },
                    // textAlign: 'left',
                    // toFixed: 2,
                }
                this.config5 = {
                    number: [0],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 21,//字体大小
                        fill: '#FFE11D',//字体颜色
                        fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                        fontWeight: 'bold'
                    },
                    textAlign: 'left',
                    // toFixed: 2,
                }
                this.config6 = {
                    number: [0],
                    style: {
                        //这里可以修改默认样式
                        fontSize: 21,//字体大小
                        fill: '#FFE11D',//字体颜色
                        fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                        fontWeight: 'bold'
                    },
                    textAlign: 'left',
                    // toFixed: 2,
                }
                setTimeout(() => {

                    this.config2 = {
                        // number: [this.middleTopInfo.cow.cowBuyQuan],
                        number: [this.cowTotal],
                        style: {
                            //这里可以修改默认样式
                            fontSize: 21,//字体大小
                            fill: '#FFE11D',//字体颜色
                            fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                            fontWeight: 'bold'
                        },
                        textAlign: 'left',
                        toFixed: 2,
                    }

                    this.config3 = {
                        number: [this.totalInventoryAmount],
                        style: {
                            //这里可以修改默认样式
                            fontSize: 21,//字体大小
                            fill: '#FFE11D',//字体颜色
                            fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                            fontWeight: 'bold'
                        },
                        textAlign: 'left',
                        toFixed: 2,
                    }
                    // console.log(this.middleTopInfo, 'this.middleTopInfo');
                    this.config4 = {
                        // number: [this.middleTopInfo.companyNum],
                        number: [Number(this.unitSheep.num)],
                        style: {
                            //这里可以修改默认样式
                            fontSize: 25,//字体大小
                            fill: '#FFE11D',//字体颜色
                            fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                            fontWeight: 'bold'
                        },
                        // textAlign: 'left',
                        toFixed: 2,
                    }
                    this.config5 = {
                        number: [this.sheepTotal],
                        style: {
                            //这里可以修改默认样式
                            fontSize: 21,//字体大小
                            fill: '#FFE11D',//字体颜色
                            fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                            fontWeight: 'bold'
                        },
                        textAlign: 'left',
                        // toFixed: 2,
                    }
                    this.config6 = {
                        number: [this.supplierNum],
                        style: {
                            //这里可以修改默认样式
                            fontSize: 21,//字体大小
                            fill: '#FFE11D',//字体颜色
                            fontFamily: ' Source Han Sans CN-Bold, Source Han Sans CN',
                            fontWeight: 'bold'
                        },
                        textAlign: 'left',
                        // toFixed: 2,
                    }
                }, 0)
            })
        },
        getTrends() {
            this.$http({
                url: 'mesapp-service/showScreen/butcherDynamic',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "materialsType": null,
                    "tenantId": this.userInfo.tenantId
                },
            }).then(res => {
                if (res.data.result) {
                    this.slaughterAd = res.data.result
                }
            })
        },
        changeYearData() {
            if (this.time == '0') {
                this.slaughterTradeDis = this.changData.slaughterTradeDis
            }
            if (this.time == '1') {
                this.slaughterTradeDis = this.changData['slaughterTradeDis-2023']
            }
            this.statusBtn('羊')
        },
        getProcessList(startTime, endTime) {
            this.$http({
                url: 'mesapp-service/showScreen/companyRank',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "materialsType": null, //原料类型 1羊 2牛，非必传，如果不传，查询牛和羊
                    "companyName": this.companyName, //企业名称，非必传，企业名称模糊查询
                    "startTime": startTime, //统计数量和金额的入场时间 开始时间，非必传
                    "endTime": endTime, //统计数量和金额的入场时间 结束时间，非必传
                    "sortBy": this.sortBy, //排行类型，非必传，默认按照结算金额排行, butcherNum 屠宰数量排行 finalAmount 结算金额排行
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    this.total = data.result.length
                    this.standbyTable = data.result
                    this.formTable = JSON.parse(JSON.stringify(data.result))
                    this.changeSpot()

                } else {
                    if (data.result == null) {
                        this.total = 0
                        this.config1 = {
                            header: [],
                            data: [],
                        }
                        return
                    }
                    // this.$message.error(data);
                }
            })
        },
        getData() {
            this.$http({
                url: 'screenapp-service/screenSlaughterProcess/page/data',
                //请求方式
                method: 'post',
                //传递的参数
                data: {
                    "parentId": "0",
                    "menuMark": "12",
                    // "dataFlag": "0",
                    // deptId: this.userInfo.dept.deptId,
                    deptId: '1552962530604911111'
                },
            }).then(res => {
                const data = res.data;
                if (res.data.code === 200) {
                    const screenData = JSON.parse(data.result.screenData)
                    // this.headerInfo = { name: data.result.screenName }
                    // console.log(screenData, 'screenData');
                    this.screenData = screenData//存储全部市级数据
                    this.changData = screenData['152500']
                    console.log(this.changData, ' this.changData');
                    this.getList()
                } else {
                    // this.$message.error(data);
                }
            })
        },
        getList() {
            this.sheepBuyPriceRank = this.changData.sheepBuyPriceRank
            this.sheepList = this.sheepBuyPriceRank.sevenDays.list
            this.cowBuyPriceRank = this.changData.cowBuyPriceRank
            this.cowList = this.cowBuyPriceRank.sevenDays.list
            // this.slaughterAd = this.changData.slaughterAd

            // this.slaughterTradeDis2023 = this.changData['slaughterTradeDis-2023']//2023年数据
            // if (this.headDate != '/nmzlqlogin') {
            //     // this.slaughterTradeDis = this.changData.slaughterTradeDis
            //     this.slaughterTradeDis = this.changData['slaughterTradeDis-2023']
            // } else {
            //     this.slaughterTradeDis = this.changData['slaughterTradeDis-2023']
            // }
            // // this.csData = this.slaughterTradeDis.cow
            // this.csData = this.slaughterTradeDis.sheep
            // this.growData = [
            //     {
            //         title: '屠宰量', label: this.slaughterTradeDis.months,
            //         value: this.csData.slaughterQuantity
            //     },
            //     {
            //         title: '交易金额', label: this.slaughterTradeDis.months,
            //         value: this.csData.tradeAmount
            //     },
            // ]

            this.$nextTick(() => {
                this.sheepData = []
                this.sheepData.push({ title: this.sheepList[0].title, label: this.sheepList[0].priceTrend.label, value: this.sheepList[0].priceTrend.value },)
                this.setLineData(this.sheepData, 'lineChart_1')
                this.cowData = []
                this.cowData.push({ title: this.cowList[0].title, label: this.cowList[0].priceTrend.label, value: this.cowList[0].priceTrend.value },)

                // this.setLineData(this.cowData, 'lineChart_2')
                // this.middleTopInfo = this.changData.middleTopInfo
                // console.log(this.middleTopInfo, '4545454545');
                // this.growthChart(this.growData)
                this.middleChange()
            })
        },
        middleChange() {
            this.breederList = []

            if (this.slaughterAd.settlementList && this.slaughterAd.settlementList.length > 0) {
                this.slaughterAd.settlementList.forEach((item) => {
                    this.breederList.push([item.checkInTime, item.supplierName, item.finalButcherNum, item.finalAmount, item.companyName])
                })
            }

            this.config = {
                header: ['入场时间', '养殖户名称', '入场数量', '结算金额(元)', '屠宰企业'],
                data: this.breederList,
                align: ['left', 'left', 'left', 'right', 'left'],
                columnWidth: [260, 200, 180, 220, 300],
                headerHeight: 35,
                rowNum: 7,
                waitTime: 2000
            }

        },
        changeMoney(num) {
            if (Number(num) <= 1) return {
                num,
                unit: '元'
            };
            var moneyUnits = ["元", "万元", "亿元", "万亿"]
            var dividend = 10000;
            var curentNum = num;
            //转换数字 
            var curentUnit = moneyUnits[0];
            //转换单位 
            for (var i = 0; i < 4; i++) {
                curentUnit = moneyUnits[i]
                if (this.strNumSize(curentNum) < 5) {
                    break;
                }
                curentNum = curentNum / dividend
            }
            var m = {
                num: 0,
                unit: ""
            }
            m.num = Number(curentNum).toFixed(2)
            m.unit = curentUnit;
            return m;
        },

        strNumSize(tempNum) {
            var stringNum = tempNum.toString()
            var index = stringNum.indexOf(".")
            var newNum = stringNum;
            if (index != -1) {
                newNum = stringNum.substring(0, index)
            }
            return newNum.length
        },
        btn() {
            if (this.sheepList.length <= 4) return
            var box = document.querySelector('.box')
            if (this.num >= 1) {
                this.num = 0
                box.style.transform = 'translateX(0)'
            } else {
                this.num = this.num + 1
                box.style.transform = `translateX(${-1.6 * this.num}rem)`
                box.style.transition = 'transform 0.5s linear'
            }

            // initial
        },
        goBack() {
            this.goBackShow = false
            this.statusBtn(this.status)
        },
        // 屠宰加工企业排行鼠标移入全部显示
        mouseover_1() {
            var divs = document.querySelectorAll('.l_b .row-item')
            // if (divs[val.rowIndex] == undefined) return
            // var node = divs[val.rowIndex].childNodes[val.columnIndex]
            // node.clientWidth < node.scrollWidth ? (node.title = val.ceil) : 'return'
            divs = [...divs]
            divs.forEach(item => {
                item.childNodes.forEach(it => {
                    (it.clientWidth < it.scrollWidth ? (it.title = it.innerText) : 'return')
                })
            })
        },
        // 羊只收购月份切换
        serviceStatusBtn(val) {
            if (val === 'first') {
                this.serviceStatus = 'first'
                this.sheepList = this.sheepBuyPriceRank.sevenDays.list
            }
            if (val === 'three') {
                this.serviceStatus = 'three'
                this.sheepList = this.sheepBuyPriceRank.thirtyDays.list
            }
            if (val === 'six') {
                this.serviceStatus = 'six'
                this.sheepList = this.sheepBuyPriceRank.threeMonth.list
            }
            this.$nextTick(() => {
                this.small_Status = 0
                this.sheepData = []
                this.sheepData.push({ title: this.sheepList[0].title, label: this.sheepList[0].priceTrend.label, value: this.sheepList[0].priceTrend.value },)
                this.setLineData(this.sheepData, 'lineChart_1')
            })
        },
        serviceStatusBtn_1(val) {
            this.serviceStatus_1 = val
            let startTime = null
            let endTime = null
            const today = new Date().toISOString().slice(0, 19).replace("T", " "); //当天日期
            // 获取三个月前的日期时间
            const threeMonthsAgo = new Date();
            threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
            const datetimeThreeMonthsAgo = threeMonthsAgo.toISOString().slice(0, 19).replace("T", " ");
            if (val === 'first_1') {
                startTime = toEnd()
                endTime = toDay()
            }
            if (val === 'three_1') {
                startTime = toThreeEnd()
                endTime = toThreeDay()
            }
            if (val === 'six_1') {
                endTime = today.split(" ")[0]
                startTime = datetimeThreeMonthsAgo.split(" ")[0]
            }
            this.trendOfFinishedProducts(startTime, endTime)
        },
        serviceStatusBtn_2(val) {
            let startTime = null
            let endTime = null
            const today = new Date().toISOString().slice(0, 19).replace("T", " "); //当天日期
            // 获取三个月前的日期时间
            const threeMonthsAgo = new Date();
            threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 3);
            const datetimeThreeMonthsAgo = threeMonthsAgo.toISOString().slice(0, 19).replace("T", " ");
            if (val === 'first_2') {

                this.serviceStatus_2 = 'first_2'
                startTime = toEnd()
                endTime = toDay()
            }
            if (val === 'three_2') {
                this.serviceStatus_2 = 'three_2'
                startTime = toThreeEnd()
                endTime = toThreeDay()
            }
            if (val === 'six_2') {
                this.serviceStatus_2 = 'six_2'
                endTime = today.split(" ")[0]
                startTime = datetimeThreeMonthsAgo.split(" ")[0]
            }
            this.getProcessList(startTime, endTime)
        },
        smallBtn(val) {
            this.smallStatus = val
            this.cowData = []
            this.cowData.push({ title: this.cowList[val].title, label: this.cowList[val].priceTrend.label, value: this.cowList[val].priceTrend.value },)
            this.setLineData(this.cowData, 'lineChart_2')

        },
        small_Btn(val) {
            this.small_Status = val
            this.sheepData = []
            this.sheepData.push({ title: this.sheepList[val].title, label: this.sheepList[val].priceTrend.label, value: this.sheepList[val].priceTrend.value },)
            this.setLineData(this.sheepData, 'lineChart_1')
        },

        // 设置折线图
        setLineData(data, dom) {
            const colors = ['#1EE7E7', '#0EDAE2', '#5931FC'];
            const legend = [];
            const series = [];
            let xAxis = [];
            data.forEach((item, index) => {
                legend.push({
                    name: item.title,
                    textStyle: { color: '#00E0DB' },
                    icon: 'circle',
                    itemWidth: 4,
                    itemhight: 4,
                })
                xAxis = item.label
                series.push({
                    name: item.title,
                    type: "line",
                    lineStyle: {
                        width: 2,
                    },
                    color: colors[index],
                    data: item.value,
                })
            })
            const line = {
                dom,
                xAxis,
                legend: {
                    data: legend,
                    // x: 'right',
                    // y: 'top',
                    top: "3%",
                    right: "3%",
                    itemWidth: 8,
                    itemHeight: 8,
                    padding: [10, 0, 0, 0],
                },
                series: series
            }
            this.lineChart(line)
        },
        lineChart(data) {
            var chart = this.$echarts.init(document.getElementById(data.dom))
            // 隐藏动画加载效果。
            var option = {
                color: ['#106BDC', '#0EDAE2', '#5931FC'],
                tooltip: {
                    trigger: 'axis',
                    formatter: function (params) {
                        // console.log(params, 'params');
                        // return `<p>
                        //           <span style="color: #FFF; font-size: 14px; font-weight: normal;">监管笔数${params.name
                        //     }： ${params.data.account || 0} </span>

                        //       </p>`;
                        return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].name
                            }</p><br/>
                         <p>
                        <p style="font-size: 14px; font-weight: normal;">${params[0].value + '元/KG'
                            }</p>
                         `;
                        // return params.name
                    },
                    padding: [5, 20],
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                legend: data.legend,
                grid: {
                    top: '25%',
                    left: '5%',
                    right: '4%',
                    bottom: '10%',
                    containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: true,
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    axisTick: {
                        // X轴线 刻度线
                        show: true,
                        inside: true,
                        alignWithLabel: true
                    },
                    data: data.xAxis,
                },
                yAxis: {
                    name: '元/KG',
                    nameTextStyle: {
                        color: '#FFFFFF',
                        padding: [3, 45, 0, 0],
                        lineHeight: 45,
                        // align:'left'
                    },
                    // nameLocation:'end',
                    type: 'value',
                    splitNumber: 3,
                    axisLine: {
                        show: false, // Y轴线
                        lineStyle: {
                            color: 'rgba(85, 193, 255, 1)',
                        },
                    },
                    splitLine: {
                        lineStyle: {
                            type: 'dashed',
                            color: 'rgba(255,255,255,0.05)'
                        }
                    },
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                },
                series: data.series,
            }
            chart.clear();
            chart.setOption(option)
            window.addEventListener('resize', () => {
                chart.resize()
            })
        },
        //折线柱状图
        growthChart(data) {
            this.chart = this.$echarts.init(document.getElementById('growthChart'));
            var option = {
                legend: {
                    top: '-0.5%',
                    // // left: '3%',
                    right: '16%',
                    // bottom: '60%',
                    // show: true,
                    itemWidth: 12,
                    itemHeight: 12,
                    data: [
                        {
                            name: data[0].title,
                            textStyle: {
                                color: '#0EDAE2'
                            },
                        },
                        {
                            name: data[1].title,
                            textStyle: {
                                color: '#00ACFC'
                            },
                            // bottom: 10
                        }
                    ]
                },
                tooltip: {//鼠标悬浮提示数据
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line'
                    },
                    formatter: (params) => {
                        if (params.length == 1) {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                                }</p><br/>
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">${params[0] && params[0].seriesName == '屠宰量' ? `屠宰量${this.status === '牛' ? '(头)' : '(只)'}：${params[0].value}` : `交易金额(万)：${params[0].value}`
                                }</span>
                        </p ><br/>       
                         `;
                            // <p>
                            //     <span style="font-size: 14px; font-weight: normal;">${params[0] && params[0].seriesName == '交易金额' ? '交易金额(万)：' : ''} ${params[0] && params[0].seriesName == '交易金额' ? params[0].value : ''} </span>
                            // </p>
                            // return params.name
                        } else if (params.length == 2) {
                            return `
                        <p style="font-size: 14px; font-weight: normal;">${params[0].axisValue
                                }</p><br/>
                        <p>
                          <span style="font-size: 14px; font-weight: normal;">${params[0] ? `屠宰量${this.status === '牛' ? '(头)' : '(只)'}：` : ''
                                } ${params[0] ? params[0].value : ''} </span>
                        </p ><br/> 
                         <p>
                          <span style="font-size: 14px; font-weight: normal;">${params[1] ? '交易金额(万)：' : ''} ${params[1] ? params[1].value : ''} </span>
                         </p>`;
                            // return params.name
                        } else {
                            return
                        }
                    },
                    // backgroundColor: 'rgba(11, 15, 56, 1)',
                    // borderColor: 'rgba(18, 36, 132, 1)',
                    // borderWidth: 2,
                    // textStyle: {
                    //     color: '#fff',
                    // },
                    backgroundColor: 'rgba(255,255,255,0.8)',
                    borderColor: '#292929',
                    borderWidth: 1,
                    textStyle: {
                        color: '#050F37',
                    },
                },
                grid: {
                    top: '10%',
                    // left: '5%',
                    // right: '6%',
                    left: '10%',
                    right: '10%',
                    bottom: '10%',
                    // containLabel: true,
                    // height: "48%",
                    // containLabel: true,
                },
                xAxis: {
                    type: 'category',
                    axisLabel: {
                        color: '#FFFFFF',
                    },
                    axisLine: {
                        show: true, // X轴 网格线 颜色类型的修改
                        lineStyle: {
                            color: '#075F73',
                        },
                    },
                    scale: false,
                    axisTick: {
                        // X轴线 刻度线
                        // show: true,
                        // inside: true,
                        // alignWithLabel: true
                        show: false,
                    },
                    data: data[0].label
                },
                yAxis: [
                    {
                        name: `屠宰量${this.status === '牛' ? '(头)' : '(只)'} `,
                        nameTextStyle: {
                            color: '#FFFFFF',
                            padding: [3, 10, 0, 0],
                            // lineHeight: 60,
                            // align:'left'
                        },
                        // nameLocation:'end',
                        type: 'value',
                        splitNumber: 4,
                        axisLine: {
                            show: false, // Y轴线
                            lineStyle: {
                                color: 'rgba(85, 193, 255, 1)',
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: 'rgba(255,255,255,0.05)'
                            }
                        },
                        axisLabel: {
                            color: '#FFFFFF',
                        },
                    },
                    {
                        name: '交易金额 (万)',
                        nameTextStyle: {
                            color: '#FFFFFF',
                            padding: [3, -15, 0, 0],
                            // lineHeight: 60,
                            // align:'left'
                        },
                        // nameLocation:'end',
                        type: 'value',
                        splitNumber: 4,
                        axisLine: {
                            show: false, // Y轴线
                            lineStyle: {
                                color: 'rgba(85, 193, 255, 1)',
                            },
                        },
                        splitLine: {
                            lineStyle: {
                                type: 'dashed',
                                color: 'rgba(255,255,255,0.05)'
                            }
                        },
                        axisLabel: {
                            color: '#FFFFFF',
                        },
                    },
                ],
                series: [
                    {
                        name: data[0].title,
                        data: data[0].value,
                        type: 'bar',
                        symbol: 'circle',
                        barWidth: 10,
                        itemStyle: {
                            opacity: 0.8,
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 1,
                                    color: '#0BE5E1',
                                },
                                {
                                    offset: 0,
                                    color: '#06FDF5',
                                },
                            ]),
                        },
                        backgroundStyle: {
                            color: 'rgba(44, 118, 254, 0.2)'
                        },
                    },
                    {
                        name: data[1].title,
                        data: data[1].value,
                        type: 'line',
                        symbol: 'circle',
                        symbolSize: 5,
                        yAxisIndex: 1,
                        itemStyle: {
                            color: '#00ACFC'
                        }
                    },
                ],
            };
            this.chart.clear()
            this.chart.setOption(option)
            window.addEventListener('resize', () => {
                this.chart.resize()
            })
            this.chart.on('click', (params) => {
                console.log(params, 'params');
                if (this.goBackShow) return
                this.goBackShow = true
                this.dataIndex = params.dataIndex + 1
                if (this.chart != null && this.chart != "" && this.chart != undefined) {
                    this.isShow = false
                }
                this.$nextTick(() => {
                    this.isShow = true
                    this.$nextTick(() => {
                        this.statusBtn(this.status)
                    })
                })

            });
        },




    },
};
</script>
<style lang="scss" scoped>
.main {
    width: 100%;

    .bank_title {
        position: relative;

        .gobcak {
            position: absolute;
            z-index: 99;
            bottom: -0.1rem;
            left: 0.16rem;
            font-size: 0.18rem;
            font-family: HarmonyOS Sans SC-Regular, HarmonyOS Sans SC;
            font-weight: 400;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            cursor: pointer;

            i {
                font-size: 0.2rem;
                color: #fff;
                margin-left: 0.1rem;
            }
        }
    }

    .city {
        width: 100%;
        height: .38rem;
        padding: 0 .25rem;

        ::v-deep .el-select {
            width: 1.9rem;

            .el-input__inner {
                // font-size: .2rem !important;
            }
        }
    }

    .content {
        position: relative;
        padding: .2rem .25rem;
        box-sizing: border-box;
        // background: url('../../assets/bg-hhr.png');
        // background-size: 100% 100%;
        display: flex;
        min-height: 12rem;
        // min-height: calc(100vh - 1.38rem);


        video {
            position: absolute;
            top: 0;
            left: 0;
            z-index: -5;
            width: 100%;
            height: 100%;
        }

        .left {
            width: 7.19rem;

            .l_t {
                height: 4.95rem;
                background: linear-gradient(180deg, rgba(0, 223, 218, 0.03) 8%, rgba(0, 223, 218, 0.01) 75%);
                border-top: 0.01rem solid rgba(0, 224, 219, 0.3);

                .block {
                    position: relative;
                    align-items: center;
                    // margin-left: .4rem;
                    margin-left: .1rem;

                    .box_ {
                        overflow: hidden;
                        width: 6rem;
                        // width: 6.87rem;
                        margin-left: .2rem;

                        .box {
                            display: flex;
                            // width: 6.87rem;
                            min-width: 10rem;
                            // margin-left: .4rem;
                            // margin-left: .2rem;

                            .small_big {
                                width: 1.25rem;
                                height: 0.63rem;
                                margin-left: .25rem;
                            }

                            .small_big:nth-child(1) {
                                // margin-left: .26rem;
                                margin-left: .15rem;
                            }
                        }
                    }

                    .img_1 {
                        width: .15rem;
                        height: .15rem;
                        position: absolute;
                        top: 0.2rem;
                        left: 0;
                        cursor: pointer;
                    }

                    .img_2 {
                        width: .15rem;
                        height: .15rem;
                        position: absolute;
                        top: 0.2rem;
                        right: 0.2rem;
                        cursor: pointer;
                    }
                }

                #lineChart_1 {
                    width: 7.19rem;
                    height: 3rem;
                    margin-top: .45rem;
                }
            }

            .l_b {
                height: 6.44rem;
                background: linear-gradient(74deg, rgba(0, 223, 218, 0.03) 8%, rgba(0, 223, 218, 0.01) 75%);
                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
                margin-top: .33rem;

                .l_top {
                    display: flex;
                    margin-left: .46rem;
                    margin-top: .33rem;

                    .top {
                        // flex: 1;

                        span {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                        }

                        span:nth-child(2) {
                            font-size: 0.38rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #00E0DB;
                            margin-left: .25rem;
                        }
                    }

                    .top:nth-child(2) {
                        margin-left: .68rem;
                    }
                }




                .bar_chart {
                    width: 100%;
                    height: 3.7rem;
                    margin-top: 0.7rem;
                }
            }
        }

        .center {
            width: 8.63rem;
            margin-left: .25rem;

            .c_t {
                height: 5rem;
                // background: linear-gradient(60deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 88%);
                background-color: #011229;
                border: 0.01rem solid rgba(0, 224, 219, 0.3);
                display: flex;

                .l {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    margin-left: .45rem;

                    // margin: .51rem 0 0 .45rem;
                    .box_1 {}

                    .box_2 {
                        // margin: 0 0 .54rem .45rem;
                    }
                }


                .box_3 {
                    position: relative;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    width: 2.38rem;
                    height: 2.38rem;
                    // background: url('../../assets/tz_center.png');
                    // background-size: 100% 100%;
                    margin-top: 1.24rem;
                    font-size: 0.48rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #FFE11D;
                    z-index: 3;

                    span:nth-child(2) {
                        font-size: 0.15rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #FFFFFF;
                        // margin-top: .25rem;
                        margin-top: .15rem;
                    }

                    video {
                        // position: absolute;
                        // top: -0.1rem;
                        // left: -0.14rem;
                        // z-index: -1;
                        // width: 2.6rem;
                        // height: 2.6rem;
                    }
                }

                .r {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                    margin-right: .44rem;

                    .box_4 {
                        // margin: 0.5rem 0.44rem 0 0;
                    }

                    .box_5 {
                        // margin: 0 .45rem .54rem 0;
                    }
                }

                .box_12 {
                    display: flex;
                    align-items: center;
                    height: 1.24rem;
                    background: url('../../assets/tz_1.png');
                    background-size: 100% 100%;

                    img {
                        width: 0.63rem;
                        height: 0.63rem;
                        display: block;
                        margin: 0 .11rem 0 .16rem;
                    }

                    .text {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;

                        span {
                            font-size: 0.43rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #FFE11D;
                            // margin-top: .05rem;
                        }

                        span:nth-child(2) {
                            font-size: 0.13rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            // margin-top: .1rem;
                        }
                    }
                }

                .box_45 {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 1.24rem;
                    background: url('../../assets/tz_2.png');
                    background-size: 100% 100%;

                    img {
                        width: 0.63rem;
                        height: 0.63rem;
                        display: block;
                        margin: 0 .15rem 0 0;
                    }

                    .text {
                        display: flex;
                        flex-direction: column;
                        align-items: flex-start;
                        margin-left: .25rem;

                        span {
                            font-size: 0.43rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #FFE11D;
                            // margin-top: .05rem;
                        }

                        span:nth-child(2) {
                            font-size: 0.13rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            // margin-top: .2rem;
                        }
                    }
                }
            }

            .c_b {
                height: 6.44rem;
                background: linear-gradient(360deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 47%);
                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
                margin-top: .26rem;

                .date {
                    span {
                        display: inline-block;
                        width: 0.44rem !important;
                        height: 0.23rem !important;
                        text-align: center;
                        line-height: .23rem;
                        padding: 0;
                    }
                }

                .l_top {
                    display: flex;
                    margin-left: .46rem;
                    margin-top: .41rem;

                    .top {
                        display: flex;
                        flex-direction: column;

                        span {
                            font-size: 0.38rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #00E0DB;
                        }

                        span:nth-child(2) {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            margin-top: .2rem;
                        }
                    }

                    .top:nth-child(2) {
                        margin-left: 1.6rem;

                    }
                }

                .l_c {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;
                    margin-right: .2rem;

                    .ret {
                        width: 0.88rem;
                        height: 0.38rem;
                        background: #013D4E;
                        border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                        opacity: 1;
                        line-height: .38rem;
                        text-align: center;
                        margin-right: .18rem;
                        font-size: 0.13rem;
                        font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                        font-weight: 400;
                        color: #00E0DB;
                        cursor: pointer;
                    }

                }

                #growthChart {
                    width: 8.63rem;
                    height: 4rem;
                    // margin: auto;
                    margin-top: .3rem;
                }
            }
        }

        .right {
            width: 7.19rem;
            margin-left: .25rem;

            .r_t {
                height: 4.95rem;
                background: linear-gradient(180deg, rgba(0, 223, 218, 0.05) 8%, rgba(0, 223, 218, 0.01) 75%);
                border-top: 0.01rem solid rgba(0, 224, 219, 0.3);

                .l_top {
                    display: flex;
                    margin-left: .26rem;
                    margin-top: .53rem;

                    .top {
                        display: flex;
                        flex-direction: column;

                        span {
                            font-size: 0.38rem;
                            font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                            font-weight: bold;
                            color: #00E0DB;
                        }

                        span:nth-child(2) {
                            font-size: 0.15rem;
                            font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                            font-weight: 400;
                            color: #FFFFFF;
                            margin-top: .2rem;
                        }
                    }

                    .top:nth-child(2) {
                        margin-left: 1.6rem;

                    }
                }

                #lineChart_2 {
                    width: 7rem;
                    height: 3rem;
                    margin-top: .45rem;
                    margin-left: .15rem;
                }

                #barChart {
                    width: 100%;
                    height: 3.17rem;
                    margin-top: .1rem;
                    margin-left: .15rem;
                    // background-color: red;
                }
            }

            .r_b {
                margin-top: .33rem;
                height: 6.44rem;
                background: linear-gradient(113deg, rgba(0, 223, 218, 0.01) 15%, rgba(0, 222, 217, 0.05) 100%);
                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);

                .video_title {
                    background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 60%) !important;
                }

                .el-dropdown {
                    min-width: 1.63rem;
                    height: 0.38rem;
                    line-height: .33rem;
                    background: rgba(0, 223, 218, 0.0588);
                    border-radius: 0rem 0rem 0rem 0rem;
                    opacity: 1;
                    border: 0.01rem solid rgba(0, 223, 218, 0.4);
                    margin-right: .25rem;
                    cursor: pointer;
                }

                .el-dropdown-link {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    background: transparent;
                    // padding: 0.05rem 0.19rem;
                    font-size: 0.15rem;
                    font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                    font-weight: 400;
                    color: #00E0DB;

                    i {
                        margin-right: .1rem;
                    }
                }

                .device_main {
                    display: flex;
                    // justify-content: center;
                    margin-left: .25rem;
                    align-items: center;
                    margin-top: .25rem;
                    position: relative;
                    // cursor: pointer;
                }

                .video_box {
                    position: relative;
                    // width: 7.63rem;
                    width: 6.69rem;
                    height: 5rem;
                    padding: .2rem;
                    border: 0.01rem solid rgba(0, 224, 219, 0.08);

                    &::after {
                        position: absolute;
                        left: 0;
                        top: 0;
                        content: "";
                        width: .18rem;
                        height: .14rem;
                        border-left: 1px solid #00E0DB;
                        border-top: 1px solid #00E0DB;
                    }

                    &::before {
                        position: absolute;
                        right: 0;
                        top: 0;
                        content: "";
                        width: .18rem;
                        height: .14rem;
                        border-right: 1px solid #00E0DB;
                        border-top: 1px solid #00E0DB;
                    }

                    .top_box {
                        position: absolute;
                        bottom: 0;
                        left: 0;
                        width: 100%;
                        height: .5rem;

                        &::after {
                            position: absolute;
                            left: 0;
                            bottom: 0;
                            content: "";
                            width: .18rem;
                            height: .14rem;
                            border-left: 1px solid #00E0DB;
                            ;
                            border-bottom: 1px solid #00E0DB;
                            ;

                        }

                        &::before {
                            position: absolute;
                            right: 0;
                            bottom: 0;
                            content: "";
                            width: .18rem;
                            height: .14rem;
                            border-right: 1px solid #00E0DB;
                            ;
                            border-bottom: 1px solid #00E0DB;
                            ;

                        }
                    }

                    .device_box {
                        // width: 7.23rem;
                        width: 6.2rem;
                        height: 4.6rem;
                        display: flex;
                        justify-content: center;
                        align-items: center;

                        video {
                            position: relative;
                            width: 100%;
                            height: 100%;
                            z-index: 1;
                        }
                    }
                }

                .quan {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-top: .3rem;
                    margin-left: .25rem;

                    .cattle_ {
                        display: flex;
                        align-items: center;
                        font-size: 0.2rem;
                        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                        font-weight: bold;
                        color: #00E0DB;

                        span:nth-child(1) {
                            display: inline-block;
                            width: 0.11rem;
                            height: 0.2rem;
                            background: #00E0DB;
                            border-radius: 0rem 0rem 0rem 0rem;
                            opacity: 1;
                            margin-right: .15rem;
                        }
                    }

                    .screenFull {
                        display: flex;
                        align-items: center;
                        font-size: 0.2rem;
                        font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                        font-weight: bold;
                        color: #00E0DB;
                        cursor: pointer;

                        img {
                            width: .25rem;
                            height: .25rem;
                            margin-right: .15rem;
                        }

                        span {
                            padding-right: .2rem;
                        }
                    }
                }
            }
        }
    }

    .server {
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 0.48rem;
        background: linear-gradient(119deg, rgba(0, 222, 217, 0.3) 19%, rgba(0, 223, 218, 0) 70%);

        // padding-top: .24rem;
        .card_ {
            font-size: 0.23rem;
            font-family: SourceHanSansCN-Regular, SourceHanSansCN;
            font-weight: 400;
            color: #00E0DB;
            padding-left: .25rem;
        }

        .date {
            // margin-left: 1.2rem;
            color: #7B8A89;
            padding-right: 0.15rem;

            span {
                padding: .03rem .05rem;
                border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Regular, Source Han Sans CN;
                background: rgba(255, 255, 255, 0.05);
                opacity: .5;
                font-weight: 400;
                cursor: pointer;
            }

            span:nth-child(2) {
                margin: 0 .13rem;
            }
        }
    }

    .active {
        background: rgba(255, 255, 255, 0.2) !important;
        // opacity: 1;
        color: #00E0DB !important;
        opacity: 1 !important;
    }

    .active_1 {
        color: #00FF9D !important;
    }

    .active_2 {
        background: rgba(0, 224, 219, 0.1);
        box-shadow: 0rem 0rem 0.13rem 0rem rgba(30, 231, 231, 0.4), inset 0rem 0rem 0.25rem 0rem rgba(30, 231, 231, 0.4);
        opacity: 1;

        &::after {
            position: absolute;
            left: 0;
            top: 0;
            content: "";
            width: 0.13rem;
            height: 0.13rem;
            opacity: 1;
            border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
            border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
        }

        &::before {
            position: absolute;
            right: 0;
            top: 0;
            content: "";
            width: 0.13rem;
            height: 0.13rem;
            opacity: 1;
            border-top: 0.01rem solid rgba(0, 224, 219, 0.3);
            border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
        }

        .top_box {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: .15rem;

            &::after {
                position: absolute;
                left: 0;
                bottom: 0;
                content: "";
                width: 0.13rem;
                height: 0.13rem;
                opacity: 1;
                border-left: 0.01rem solid rgba(0, 224, 219, 0.3);
                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
            }

            &::before {
                position: absolute;
                right: 0;
                bottom: 0;
                content: "";
                width: 0.13rem;
                height: 0.13rem;
                opacity: 1;
                border-bottom: 0.01rem solid rgba(0, 224, 219, 0.3);
                border-right: 0.01rem solid rgba(0, 224, 219, 0.3);
            }
        }

    }

    .block {
        display: flex;
        margin-top: .35rem;

        .small_big {
            position: relative;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-left: .41rem;
            width: 1.25rem;
            height: 0.63rem;

            cursor: pointer;


            span {
                font-size: 0.2rem;
                font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                font-weight: bold;
                color: #00E0DB;

                i {
                    font-size: 0.13rem;
                    font-weight: 400;
                    font-style: normal;
                }
            }

            span:nth-child(2) {
                font-size: 0.13rem;
                font-family: Source Han Sans CN-Normal, Source Han Sans CN;
                font-weight: 400;
                color: #FFFFFF;
                margin-top: .07rem;
            }
        }
    }

    .big_box {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 0;
        left: 0;
        background: rgba(0, 0, 0, 1);
        z-index: 99999;
    }

    .video_b {
        position: relative;
        // top: 25%;
        // left: 25%;
        width: 18.02rem;
        height: 10.14rem;
        background: url('../../assets/video_bg.png');
        background-size: 100% 100%;
        opacity: 1;
        display: flex;

        .close_icon {
            position: absolute;
            top: .25rem;
            right: .25rem;
            color: #00e0db;
            font-size: .3rem;
            cursor: pointer;
        }

        .show_video {
            width: 14rem;
            height: 8.68rem;
            margin-left: .4rem;
            margin-top: .2rem;

            .quan {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: .56rem;


                .cattle_ {
                    display: flex;
                    align-items: center;
                    font-size: 0.2rem;
                    font-family: Source Han Sans CN-Bold, Source Han Sans CN;
                    font-weight: bold;
                    color: #00E0DB;

                    span:nth-child(1) {
                        display: inline-block;
                        width: 0.11rem;
                        height: 0.2rem;
                        background: #00E0DB;
                        border-radius: 0rem 0rem 0rem 0rem;
                        opacity: 1;
                        margin-right: .15rem;
                    }
                }
            }

            #myVideo1 {
                margin-top: .2rem;
                // width: 14rem !important;
                width: 14.34rem !important;
                height: 8.68rem !important;
            }
        }

        .listVideo {
            display: flex;
            flex-direction: column;
            font-size: 0.15rem;
            font-family: Source Han Sans CN-Medium, Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
            overflow: auto;
            margin: 1rem 0 .1rem .55rem;

            .list_video {
                position: relative;
                // width: 3.2rem;
                width: 2.69rem;
                // width: 3.34rem;
                height: 1.8rem;
                margin-top: .4rem;
                cursor: pointer;

                span {
                    padding-top: .2rem !important;
                }

                .box_img {
                    position: relative;
                    width: 2.69rem;
                    height: 1.61rem;
                    margin-top: .2rem;
                }

                img {
                    width: 100%;
                    height: 100%;
                    // padding-top: .2rem;
                    // width: 3.2rem;
                    // width: 2.69rem;
                    // height: 1.8rem;
                }

                #shoadow {
                    position: absolute;
                    top: 0;
                    left: 0;
                    background-color: rgba(0, 0, 0, 0.5);
                    // margin-top: .37rem;
                    // width: 2.69rem;
                    // height: 1.61rem;
                    text-align: center;
                    line-height: 1.8rem;
                    width: 100%;
                    height: 100%;
                }

                // #video3 {
                //     margin-top: .2rem;
                //     width: 3.34rem;
                //     height: 1.6rem;
                // }
            }

            .list_video:nth-child(1) {
                margin-top: .2rem;
            }
        }
    }
}

// element样式
::v-deep .el-table th {
    background: rgba(0, 224, 219, 0.08) !important;
    color: #00E0DB;
}

::v-deep .el-table tr {
    background: transparent !important;
    color: #FFFFFF;
}

::v-deep .el-table td.el-table__cell {
    border: none !important;
}

::v-deep .el-table th.el-table__cell.is-leaf {
    border: none !important;
}

::v-deep .el-table__body tr:hover>td {
    background-color: rgba(0, 59, 81, 0.49) !important;
}

::v-deep .el-table::before {
    height: 0px;
}
</style>
<style lang="scss">
.slaughter {
    .slaughter .dv-digital-flop canvas {
        text-align: left !important;
        width: 80% !important;
        height: 80% !important;
    }

    // .dv-digital-flop canvas {
    //     width: 80% !important;
    //     height: 80% !important;
    //     margin-left: .2rem !important;
    // }

    .active-ring-name {
        font-size: .23rem !important;
        padding-top: .1rem;
    }

    .el-input__inner {
        // width: 2.79rem;
        height: 0.38rem;
        background: rgba(0, 224, 219, 0.08) !important;
        border: none;
        border-radius: 0.03rem;
        color: #FFFFFF !important;
        font-size: .13rem !important;
    }

    .el-input__icon {
        color: #00E0DB;
    }

    //下拉
    .el-select {
        width: 1.5rem;
        height: 0.38rem;
        line-height: .38rem;
        background: rgba(0, 223, 218, 0.0588);
        border-radius: 0rem 0rem 0rem 0rem;
        opacity: 1;
        border: 0.01rem solid rgba(0, 223, 218, 0.4);

        .el-input__inner {
            // width: 2.79rem;
            height: 0.38rem;
            line-height: .38rem;
            color: #00E0DB !important;
            font-size: .13rem !important;
        }
    }

    .el-select .el-input .el-select__caret {
        color: #00E0DB !important;
        line-height: inherit;

    }

    .search_input>.el-input__inner {
        padding: 0 0 0 .4rem;
        //     background: url('../../assets/search\ \(1\).png') no-repeat;
        //    background-position: .1rem,.1rem;
    }

    .el-input--suffix .el-input__inner {
        padding-left: .1rem;
    }

    .header {
        background: rgba(0, 224, 219, 0.08) !important;

    }

    // DataV
    .header-item {
        font-size: .175rem !important;
        opacity: .85;
        color: #00E0DB;
    }

    .dv-scroll-board .rows .ceil:nth-child(3) {
        // overflow:unset !important;
        // text-overflow:inherit !important;
        // white-space: pre-wrap !important;
        // box-sizing: none!important;
    }

    .rows {
        padding: .1rem 0 .2rem 0;
    }

    .row-item {
        background: transparent !important;

        div:nth-child(7) {
            span {
                margin-left: .6rem !important;
            }
        }

    }

    .row-item:hover {
        background-color: rgba(255, 255, 255, 0.05) !important;
    }

    .ceil {
        font-size: .15rem !important;
    }

    // .ceil:first-child {
    //     color: #FFC300;
    // }
    ::v-deep .dv-digital-flop {
        font-size: 0.43rem !important;
        font-family: Source Han Sans CN-Bold, Source Han Sans CN !important;
        font-weight: bold !important;
        color: #FFE11D !important;
        margin-top: .05rem !important;
    }


}
</style>